import { render } from "./ContactUsPage.vue?vue&type=template&id=8db73b44&scoped=true"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"

import "./ContactUsPage.vue?vue&type=style&index=0&id=8db73b44&scoped=true&lang=css"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db73b44"]])

export default __exports__